import { OnInit } from '@angular/core';
import { OccurencesService } from '../../occurences.service';
import { FormGroup } from '@angular/forms';
import { SnackbarService } from '../../../../app/shared/services/snackbar.service';
import { ConfirmDialogComponent } from '../../../shared/confirm-dialog/confirm-dialog.component';
import { MatBottomSheet } from '@angular/material';
import { UtilService } from '../../../../app/shared/utils';
var OccurenceAttachmentsComponent = /** @class */ (function () {
    function OccurenceAttachmentsComponent(occurenceService, _snackbarService, bottomSheet, utils) {
        this.occurenceService = occurenceService;
        this._snackbarService = _snackbarService;
        this.bottomSheet = bottomSheet;
        this.utils = utils;
        this.filesToUpload = new Array();
        this.errorDownloadFile = false;
    }
    OccurenceAttachmentsComponent.prototype.ngOnInit = function () {
        if (this.filesSelected) {
            if (this.filesSelected.length > 0 || this.filesToUpload.length > 0) {
                this.haveFiles = true;
            }
        }
    };
    OccurenceAttachmentsComponent.prototype.onEventFilesToUpload = function ($event) {
        // Atualiza o form
        this.filesForm.controls.files.setValue(this.filesToUpload);
        if (this.filesToUpload) {
            this.haveFiles = this.filesToUpload.length === 0 ? false : true;
        }
    };
    // Checa a existência de um arquivo no array utilizando a propriedade name e retorna seu indice
    OccurenceAttachmentsComponent.prototype.getUploadIndexByName = function (name) {
        return this.filesToUpload.findIndex(function (upload) { return upload.name === name; });
    };
    OccurenceAttachmentsComponent.prototype.deleteAttachment = function (name, event) {
        var _this = this;
        var index = this.getUploadIndexByName(name);
        if (this.filesToUpload && index >= 0) {
            var sheetRef = this.bottomSheet.open(ConfirmDialogComponent, {
                data: { message: 'Confirma a exclusão do arquivo?' }
            });
            sheetRef.afterDismissed().subscribe(function (data) {
                if (data && data.message === 'Confirm') {
                    _this.haveFiles = _this.filesToUpload.length === 0 ? false : true;
                    _this.filesToUpload.splice(index, 1);
                    _this._snackbarService.showSnackbar("Arquivo excluído com sucesso.", "OK");
                }
            });
        }
        else {
            this._snackbarService.showSnackbar("O arquivo n\u00E3o foi exclu\u00EDdo. Por favor, tente novamente.\n      Caso o problema persista, contate o seu canal de atendimento.", "OK");
        }
    };
    OccurenceAttachmentsComponent.prototype.getSizeText = function (file) {
        return (file.size / Math.pow(1024, 2)).toFixed(2).replace(/[.,]00$/, "") + " " + "MB";
    };
    OccurenceAttachmentsComponent.prototype.downloadOccurenceFileById = function (idFile) {
        var _this = this;
        this.occurenceService
            .downloadOcurrenceFileById(idFile)
            .subscribe(function (resp) {
            _this.errorDownloadFile = false;
            var body = resp.body;
            var fileName = body.fileName, contentFile = body.contentFile;
            var blob = _this.utils.convertByteJsonToBlob(contentFile);
            _this.utils.downloadFileBlob(blob, fileName);
        }, function (err) {
            _this.errorDownloadFile = true;
        });
    };
    Object.defineProperty(OccurenceAttachmentsComponent.prototype, "listAttachmentsRecent", {
        get: function () {
            if (this.filesSelected && Array.isArray(this.filesSelected) && this.filesSelected.length > 0) {
                return this.filesSelected.sort(function (a, b) {
                    return new Date(b.update) - new Date(a.update);
                });
            }
        },
        enumerable: true,
        configurable: true
    });
    return OccurenceAttachmentsComponent;
}());
export { OccurenceAttachmentsComponent };
